<div class="h-full bg-cover" style="background: url('./assets/images/wave-bg.svg');" @fadeIn>
  <div class="flex-col justify-center p-20 mx-auto md:p-30 md:flex md:h-full max-w-1280">
    <div class="flex flex-row items-center mb-20 md:mb-30 md:min-h-50" @fadeIn>
      <h2 class="flex items-center text-lg font-bold text-white">
        <span>E-Applications</span>
      </h2>
    </div>
    <app-application-history-table class="flex h-full"></app-application-history-table>
  </div>
</div>